import React, { useCallback } from 'react';
import { Tab, Tabs } from '@curves/ui-base';

import PropTypes from 'prop-types';
import useTabState from '@Util/hook/useTabState';
const CommonTabs = ({ tabs, activeTab: controlledActiveTab, onTabChange: controlledOnTabChange, ...rest }) => {
    const activeTab = controlledActiveTab || tabs[0]?.value || '';
    const { activeTab: internalActiveTab, handleTabChange: setInternalActiveTab } = useTabState(activeTab);
    const isControlled = controlledActiveTab !== undefined && controlledOnTabChange !== undefined;
    const handleTabChange = useCallback(
        (event, newValue) => {
            if (isControlled) {
                controlledOnTabChange(event, newValue);
            } else {
                setInternalActiveTab(newValue);
            }
        },
        // eslint-disable-next-line
        [isControlled, controlledOnTabChange],
    );
    return (
        <Tabs value={internalActiveTab} onChange={handleTabChange} {...rest}>
            {tabs.map(({ label, value, icon: IconComponent = null, component: Component, to }) => (
                <Tab
                    key={value}
                    className={'py-3'}
                    label={
                        <>
                            {IconComponent && React.createElement(IconComponent, { className: 'mr-2' })}
                            {label}
                        </>
                    }
                    value={value}
                    component={Component}
                    to={to}
                />
            ))}
        </Tabs>
    );
};
CommonTabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.node.isRequired,
            value: PropTypes.string.isRequired,
            // icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.node, PropTypes.oneOf([null, undefined])]), Allen TODO: observe
            component: PropTypes.elementType,
            to: PropTypes.string,
        }),
    ).isRequired,
    activeTab: PropTypes.string,
    onTabChange: PropTypes.func,
};
export default CommonTabs;
